var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRivers = function SvgRivers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M802.345 743.641L815.165 751.881L977.005 856.021",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M981.464 486.859H959.584H802.344L679.424 522.439L596.924 546.299L563.744 555.899V597.539",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M959.577 664.799V486.859",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M892.295 742.422L815.155 751.882",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M802.345 619.375V486.875",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M802.345 668.406V743.646",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M892.299 742.422L976.999 784.782",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M981.459 707.957L892.299 664.797V742.417",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M892.299 664.797H977.459",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.081 743.641L212.261 751.881L50.4214 856.021",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.96 486.859H67.84H225.08L348 522.439L430.5 546.299L463.68 555.899V597.539",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9602 947.375L348 695.355L463.68 597.555H563.74L679.42 695.355L977.46 947.375",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8452 486.859V664.799",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.256 751.882L135.116 742.422",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.077 619.375V486.875",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.077 668.406V743.646",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.121 742.422L50.4214 784.782",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.96 707.957L135.12 664.797V742.417",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.12 664.797H49.9602",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267.479 489.317L315.139 460.557C351.119 442.077 392.579 432.297 434.879 432.297H613.379C650.539 432.297 687.138 439.857 719.978 454.297L793.139 496.217",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.963 486.88V172.72C122.963 153.54 138.503 138 157.683 138C176.863 138 192.403 153.54 192.403 172.72V179.4",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.423 368.148V465.388",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.101 336.703V423.023",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M346.616 292.289V379.869",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M427.779 295.852V374.992",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M523.062 291.773V375.013",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M637.704 295.852V374.992",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M709.178 292.289V379.869",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M803.139 349.211V437.571",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M896.076 387.244V486.844L735.596 401.744C702.456 384.164 665.516 374.984 627.996 374.984H416.016C373.316 374.984 331.476 386.884 295.156 409.344L169.936 486.824",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M896.083 389.305L735.603 304.205C702.463 286.625 665.523 277.445 628.003 277.445H416.023C373.323 277.445 331.483 289.345 295.163 311.805L122.963 396.945",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.421 250.473C209.498 250.473 223.341 236.629 223.341 219.553C223.341 202.476 209.498 188.633 192.421 188.633C175.345 188.633 161.501 202.476 161.501 219.553C161.501 236.629 175.345 250.473 192.421 250.473Z",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M896.095 486.876V256.476V172.736C896.095 153.556 880.555 138.016 861.375 138.016C842.195 138.016 826.655 153.556 826.655 172.736V179.416",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M826.661 250.473C843.738 250.473 857.581 236.629 857.581 219.553C857.581 202.476 843.738 188.633 826.661 188.633C809.584 188.633 795.741 202.476 795.741 219.553C795.741 236.629 809.584 250.473 826.661 250.473Z",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M351.758 889.666C362.558 910.606 384.418 924.906 409.618 924.906C437.438 924.906 461.178 907.466 470.498 882.906",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M232.6 889.666C243.4 910.606 265.26 924.906 290.46 924.906C318.28 924.906 342.02 907.466 351.34 882.906",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M470.502 882.906C479.822 907.466 503.562 924.906 531.382 924.906C556.582 924.906 578.442 910.606 589.242 889.666",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M553.076 748.461C560.776 763.381 576.356 773.561 594.296 773.561C614.116 773.561 631.036 761.141 637.676 743.641",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M468.179 748.461C475.879 763.381 491.459 773.561 509.399 773.561C529.219 773.561 546.139 761.141 552.779 743.641",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M421.382 659.744C425.222 667.204 433.022 672.304 442.002 672.304C451.922 672.304 460.362 666.084 463.682 657.344",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M637.704 743.641C644.344 761.141 661.264 773.561 681.084 773.561C699.044 773.561 714.624 763.381 722.304 748.461",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRivers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/rivers.svg";